export default function flags(state = {}, action = null) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
				return action.payload;

			// no default
		}
	}

	return state;
}
